import React, { useEffect, useState } from 'react';
import AppLayout from '../../components/layout/AppLayout';
import { PageHeader, KpiCard, StatusBadge, EmptyState } from '../../components/common/PageHeader';
import api from '../../lib/api';
import { Link } from 'react-router-dom';
import { Plus, Briefcase, Clock, CheckCircle, Calendar, ExternalLink } from 'lucide-react';
import { statusLabel, serviceTypeLabel, meetingToolLabel } from '../../lib/constants';

const CustomerDashboard = () => {
  const [stats, setStats] = useState(null);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    (async () => {
      const [s, j] = await Promise.all([api.get('/dashboard/stats'), api.get('/jobs')]);
      setStats(s.data); setJobs(j.data);
    })();
  }, []);

  if (!stats) return <AppLayout><div>Lade...</div></AppLayout>;

  const upcoming = jobs.filter(j => !['abgeschlossen', 'storniert'].includes(j.status)).slice(0, 5);

  return (
    <AppLayout>
      <PageHeader title="Willkommen" description="Ihre Aufträge und Termine im Überblick">
        <Link to="/customer/book" data-testid="new-booking-btn" className="bg-[#0F4C81] hover:bg-[#0A365C] text-white font-medium rounded-md px-4 py-2 text-sm inline-flex items-center gap-2">
          <Plus className="w-4 h-4" /> Neuen Termin buchen
        </Link>
      </PageHeader>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
        <KpiCard label="Offene Aufträge" value={stats.open} icon={Clock} testid="kpi-open" />
        <KpiCard label="Gesamt" value={stats.total} icon={Briefcase} testid="kpi-total" />
        <KpiCard label="Abgeschlossen" value={stats.completed} icon={CheckCircle} testid="kpi-completed" />
      </div>

      <div className="bg-white border border-slate-200 rounded-md card-subtle">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <h2 className="font-heading text-base font-medium text-slate-900">Kommende Termine</h2>
          <Link to="/customer/jobs" className="text-xs text-[#0F4C81] hover:underline">Alle anzeigen</Link>
        </div>
        {upcoming.length === 0 ? (
          <div className="p-8"><EmptyState icon={Calendar} title="Keine kommenden Termine" description="Buchen Sie Ihren ersten Dolmetschtermin." action={<Link to="/customer/book" className="inline-block mt-2 bg-[#0F4C81] hover:bg-[#0A365C] text-white font-medium rounded-md px-4 py-2 text-sm">Jetzt buchen</Link>} /></div>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-3 px-4">Datum</th>
                <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-3 px-4">Sprache</th>
                <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-3 px-4">Einsatzart</th>
                <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-3 px-4">Status</th>
                <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-3 px-4">Meeting</th>
              </tr>
            </thead>
            <tbody>
              {upcoming.map(j => (
                <tr key={j.id} className="hover:bg-slate-50">
                  <td className="border-b border-slate-100 py-3 px-4 text-sm text-slate-900">{j.date} {j.time}</td>
                  <td className="border-b border-slate-100 py-3 px-4 text-sm text-slate-700">{j.source_language} → {j.target_language}</td>
                  <td className="border-b border-slate-100 py-3 px-4 text-sm text-slate-700">{serviceTypeLabel(j.service_type)}</td>
                  <td className="border-b border-slate-100 py-3 px-4"><StatusBadge status={j.status} label={statusLabel(j.status)} /></td>
                  <td className="border-b border-slate-100 py-3 px-4">
                    {j.meeting_link ? (
                      <a href={j.meeting_link} target="_blank" rel="noreferrer" data-testid={`meeting-link-${j.id}`} className="inline-flex items-center gap-1 text-xs bg-[#0F4C81] hover:bg-[#0A365C] text-white font-medium rounded px-2 py-1">
                        <ExternalLink className="w-3 h-3" /> {meetingToolLabel(j.meeting_tool)}
                      </a>
                    ) : <span className="text-xs text-slate-400">-</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AppLayout>
  );
};

export default CustomerDashboard;
